import { createSlice } from "@reduxjs/toolkit";
import { IUIState } from "types/ui/ui.type";

const initialState: IUIState = {
  currentPage: null,
  previousRoute: null,
  triggerApplyFilters: false,
  filterOpen: false,
  exportOpen: false,
  bulkSerch: false,
  sidebarOpen: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPreviousRoute: (state, action) => {
      state.previousRoute = action.payload;
    },
    setTriggerApplyFilters: (state, action) => {
      state.triggerApplyFilters = action.payload;
    },
    handleToggleFilter: (state) => {
      state.filterOpen = !state.filterOpen;
    },
    handleToggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    handleToggleExport: (state) => {
      state.exportOpen = !state.exportOpen;
      if (state.exportOpen) state.bulkSerch = false;
    },
    handleToggleBulkSearch: (state) => {
      state.bulkSerch = !state.bulkSerch;
      if (state.bulkSerch) state.exportOpen = false;
    },
  },
});

export const {
  setCurrentPage,
  setTriggerApplyFilters,
  handleToggleFilter,
  handleToggleExport,
  handleToggleSidebar,
  handleToggleBulkSearch,
  setPreviousRoute,
} = uiSlice.actions;
